/*
 * Copyright (C) 2023 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
export enum PostfachMailListLinkRel {
  POSTFACH_MAIL_LIST = 'postfachMailList',
  DOWNLOAD_ATTACHMENTS = 'downloadAttachments',
  SEND_POSTFACH_MAIL = 'sendPostfachMail',
  UPLOAD_ATTACHMENT = 'uploadAttachment',
  RESET_HAS_NEW_POSTFACH_NACHRICHT = 'resetHasNewPostfachNachricht',
  SET_HAS_NEW_POSTFACH_NACHRICHT = 'setHasNewPostfachNachricht',
}

export enum PostfachMailLinkRel {
  CREATED_BY = 'createdBy',
  RESEND_POSTFACH_MAIL = 'resendPostfachMail',
  ATTACHMENTS = 'attachments',
  EDIT = 'edit',
  SEND = 'send',
}
